import raphaelleAtlaniPicture from '../assets/Raphaelle_ATLANI.png';
import laureMahe from '../assets/Laure_MAHE.png';
import pierreAntaoineNonotteVarlyPicture from '../assets/Pierre-Antoine_NONOTTE-VARLY.jpg';
import alicePacqueletPicture from '../assets/alice_pacquelet.png';
import annececileCasabiancaPicture from '../assets/anne-cecile_casabianca.png';
import estelleMergerLevisPicture from '../assets/estelle_merger-levis.png';
import IContact from '../interfaces/IContact';

const contacts: IContact[] = [
	{
		firstName: 'Raphaelle',
		lastName: 'Atlani',
		position: 'investor_relations',
		email: 'raphaelle.atlani@sienna-im.com',
		img: raphaelleAtlaniPicture as string,
	},
	{
		firstName: 'Laure',
		lastName: 'Mahé',
		position: 'investor_relations',
		email: 'laure.mahe@sienna-im.com',
		img: laureMahe as string,
	},
	{
		firstName: 'Pierre-Antoine',
		lastName: 'Nonotte-Varly',
		position: 'director_of_development',
		email: 'pa.nonotte-varly@sienna-im.com',
		img: pierreAntaoineNonotteVarlyPicture as string,
	},
	{
		firstName: 'Alice',
		lastName: 'Pacquelet',
		position: 'client_service_officer_woman',
		email: 'alice.pacquelet@sienna-im.com',
		img: alicePacqueletPicture as string,
	},
	{
		firstName: 'Anne-Cécile',
		lastName: 'Casabianca',
		position: 'head_of_client_service',
		email: 'anne-cecile.casabianca@sienna-im.com',
		img: annececileCasabiancaPicture as string,
	},
	{
		firstName: 'Estelle',
		lastName: 'Merger-Lévis',
		position: 'sales_director_woman',
		email: 'estelle.merger-levis@sienna-im.com',
		img: estelleMergerLevisPicture as string,
	},
];

export default contacts;
